import { useRef, useState } from "react";
import { Button as BaseButton } from "@base-ui/react/button";
import { Loader2, UploadCloud } from "lucide-react";
import { cn } from "@/lib/utils";

export function Dropzone({
  uploading,
  onFiles,
}: {
  uploading: boolean;
  onFiles: (files: FileList | File[]) => void;
}) {
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [isDragging, setDragging] = useState(false);

  return (
    <>
      <BaseButton
        className={cn(
          "mx-4 mt-4 flex min-h-36 w-[calc(100%-2rem)] flex-col items-center justify-center gap-2 rounded-lg border border-dashed bg-neutral-50 px-4 text-center outline-none transition-[background-color,border-color,box-shadow]",
          "focus-visible:ring-2 focus-visible:ring-neutral-950 focus-visible:ring-offset-2",
          isDragging ? "border-neutral-950 bg-white shadow-[inset_0_0_0_1px_rgba(0,0,0,0.86)]" : "border-neutral-300 hover:border-neutral-500 hover:bg-white",
        )}
        onClick={() => fileInputRef.current?.click()}
        onDragOver={(event) => {
          event.preventDefault();
          setDragging(true);
        }}
        onDragLeave={() => setDragging(false)}
        onDrop={(event) => {
          event.preventDefault();
          setDragging(false);
          onFiles(event.dataTransfer.files);
        }}
      >
        {uploading ? <Loader2 className="animate-spin text-neutral-950" size={30} /> : <UploadCloud className="text-neutral-700" size={32} />}
        <strong className="text-sm font-medium text-neutral-950">
          {uploading ? "Uploading..." : "Drop files or images here"}
        </strong>
        <span className="text-sm text-neutral-600">or click to browse</span>
        <small className="text-xs text-neutral-500">Max 25 MB per file</small>
      </BaseButton>
      <input
        ref={fileInputRef}
        type="file"
        multiple
        hidden
        onChange={(event) => {
          if (event.target.files) {
            onFiles(event.target.files);
          }
          event.currentTarget.value = "";
        }}
      />
    </>
  );
}
